// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3S6QX","legacyBtn":"MutateMid_legacyBtn__2heKi"};